// extracted by mini-css-extract-plugin
export default {"container":"HO-z","topReviewHeading":"IO-z","criticalReview":"JO-z","favorableReview":"KO-z","vsSeparator":"LO-z"};